import { render } from "./BlogImplantsGoldStandard.vue?vue&type=template&id=99642dbc"
import script from "./BlogImplantsGoldStandard.vue?vue&type=script&lang=js"
export * from "./BlogImplantsGoldStandard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__